import React from "react";
import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import CodeReferencePreview, {
    CodeReferencePreviewProps,
} from "organisms/code-reference-block-editor/code-reference-preview";

interface ClosableCodeReferencePreviewProps extends CodeReferencePreviewProps {
    onClose: () => void;
}

const CSS_CLASS_NAME = "c-closable-code-reference-block-content";

export const ClosableCodeReferencePreview: React.FC<
    ClosableCodeReferencePreviewProps
> = (props: ClosableCodeReferencePreviewProps): JSX.Element => {
    const { onClose } = props;

    const handleCloseClick = () => onClose();

    return (
        <div className={CSS_CLASS_NAME}>
            <CodeReferencePreview {...props} />
            <Button
                cssClassName={`${CSS_CLASS_NAME}__close-button`}
                onClick={handleCloseClick}
                size={ButtonSizes.Small}
                style={ButtonStyles.TertiaryAlt}>
                <Icon type={Icons.Close} size={IconSizes.Medium} />
            </Button>
        </div>
    );
};
